import { InteractionEvent, InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';

export function trackSavePriceDropAlert(): void {
  trackEventHarmonized(InteractionEvent.BUTTON_CLICK, {
    h_event_category_006: InteractionEvent.BUTTON_CLICK,
    h_event_action_007: InteractionGoal.SAVE_PRICE_DROP_ALERTS,
    h_event_label_008: undefined,
    h_subscription_id_searchalert_030: undefined,
  });
}
